import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableHead: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '2fr 4fr 3fr 3fr 4fr 4fr 1fr',
    paddingLeft: 12,
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : '#f7f7f7'
  }
}))
export default useStyles
